module.exports = __webpack_public_path__ + "static/media/maki.3b8f2d60.png";